export default __webpack_public_path__ + "static/media/logo-bialab.0a6b6677.webp";